import React, { useCallback, useState } from 'react'
import PlaidLink from '@components/common/PlaidLink/PlaidLink.component'
import plaidIcon from '@assets/images/plaid-logo.png'
import IntegrationCard from '../stripe/IntegrationCard.component'

const Plaid: React.FC = () => {
  const [plaidStatus, setPlaidStatus] = useState({
    bankName: '',
    isLinked: false,
  })

  const handleStatusChange = useCallback(
    (details: { isLinked: boolean; linkedInstitutionName: string }): void => {
      setPlaidStatus({
        bankName: details.linkedInstitutionName,
        isLinked: details.isLinked,
      })
    },
    [],
  )

  return (
    <IntegrationCard
      name={plaidStatus.bankName ? `Plaid (${plaidStatus.bankName})` : 'Plaid'}
      icon={plaidIcon}
      statusLabel={plaidStatus.isLinked ? 'Connected' : 'Not connected'}
      statusColor={plaidStatus.isLinked ? 'vivid-green' : 'gray'}
    >
      <PlaidLink onStatusChange={handleStatusChange} />
    </IntegrationCard>
  )
}

export default Plaid
